"use client";
import { cn } from "@/lib/utils";
import { Link } from "next-view-transitions";
import { useState } from "react";
import { IoIosMenu } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { Button } from "../button";
import { Logo } from "../Logo";
import { useMotionValueEvent, useScroll } from "framer-motion";
import { ModeToggle } from "../mode-toggle";
import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "next/navigation";

export const MobileNavbar = ({ navItems }: any) => {
  const [open, setOpen] = useState(false);
  const { scrollY } = useScroll();
  const [showBackground, setShowBackground] = useState(false);
  const locale = useLocale();
  const pathname = usePathname();
  const router = useRouter();
  const t = useTranslations("nav");

  useMotionValueEvent(scrollY, "change", (value) => {
    setShowBackground(value > 100);
  });

  const switchLocale = (newLocale: string) => {
    const newPath = pathname.replace(`/${locale}`, `/${newLocale}`);
    router.push(newPath);
    setOpen(false);
  };

  return (
    <div
      className={cn(
        "flex justify-between bg-white dark:bg-neutral-900 items-center w-full rounded-full px-2.5 py-1.5 transition duration-200",
        showBackground &&
          "bg-neutral-50 dark:bg-neutral-900 shadow-[0px_-2px_0px_0px_var(--neutral-100),0px_2px_0px_0px_var(--neutral-100)] dark:shadow-[0px_-2px_0px_0px_var(--neutral-800),0px_2px_0px_0px_var(--neutral-800)]"
      )}
    >
      <Logo />
      <IoIosMenu
        className="text-black dark:text-white h-6 w-6"
        onClick={() => setOpen(!open)}
      />
      {open && (
        <div className="fixed inset-0 bg-white dark:bg-black z-50 flex flex-col items-start justify-start space-y-10 pt-5 text-xl text-zinc-600 transition duration-200 hover:text-zinc-800">
          <div className="flex items-center justify-between w-full px-5">
            <Logo />
            <div className="flex items-center space-x-2">
              <ModeToggle />
              <IoIosClose
                className="h-8 w-8 text-black dark:text-white"
                onClick={() => setOpen(!open)}
              />
            </div>
          </div>
          <div className="flex flex-col items-start justify-start gap-[14px] px-8">
            {navItems.map((navItem: any, idx: number) => (
              <Link
                key={`link-${idx}`}
                href={navItem.link}
                onClick={() => setOpen(false)}
                className="relative"
              >
                <span className="block text-[26px] text-black dark:text-white">
                  {navItem.title}
                </span>
              </Link>
            ))}
          </div>

          {/* Locale switcher */}
          <div className="flex items-center gap-3 px-8">
            <span className="text-sm text-neutral-500">Language:</span>
            <div className="flex items-center gap-1 rounded-full border border-neutral-200 dark:border-neutral-700 px-1 py-0.5">
              <button
                onClick={() => switchLocale("en")}
                className={cn(
                  "text-sm px-3 py-1 rounded-full transition-colors",
                  locale === "en"
                    ? "bg-neutral-900 dark:bg-white text-white dark:text-black font-medium"
                    : "text-neutral-500"
                )}
              >
                EN
              </button>
              <button
                onClick={() => switchLocale("de")}
                className={cn(
                  "text-sm px-3 py-1 rounded-full transition-colors",
                  locale === "de"
                    ? "bg-neutral-900 dark:bg-white text-white dark:text-black font-medium"
                    : "text-neutral-500"
                )}
              >
                DE
              </button>
            </div>
          </div>

          <div className="flex flex-row w-full items-start gap-2.5 px-8 py-4">
            <Button as={Link} href="/signup">
              {t("signup")}
            </Button>
            <Button variant="simple" as={Link} href="/login">
              {t("login")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
